import React, { Fragment } from 'react'
import { Box, Button, Flex, useDisclosure } from '@chakra-ui/react'

import { DashboardHeader, withApp } from '@/features/Layout'

import { Admin } from '@/features/admins/types'
import { Meta } from '@/features/filters/types'

import { Pagination } from '@/components/shared/Pagination'
import { AdminTable } from './AdminTable'
import { CreateAdminModal } from '@/features/admins/components'

import { useAdmins } from '@/features/admins/queries'
import { useMeta } from '@/features/filters'
import { t } from '@/lib/helpers'

type Props = {
  admins: Admin[]
  meta: Meta
}

function AdminsPage(props: Props) {
  const { admins: initialAdmins, meta: initialMeta } = props

  const disclosure = useDisclosure()

  const { meta, setMeta } = useMeta(initialMeta)
  const { data: admins } = useAdmins({
    initialData: { data: initialAdmins, meta: initialMeta },
    params: meta,
  })

  return (
    <Fragment>
      <Box layerStyle="container">
        <DashboardHeader
          title={t('views.admin.admins.index.title')}
          addons={
            <Button
              onClick={disclosure.onOpen}
              sx={{ h: '48px', minW: '100px' }}
            >
              {t('views.admin.admins.index.new')}
            </Button>
          }
        />

        <Box sx={{ mb: '24px' }}>
          <AdminTable data={admins.data} />
        </Box>

        <Flex layerStyle="content" sx={{ justifyContent: 'flex-end' }}>
          <Pagination
            page={meta.page}
            per={meta.per}
            total={meta.total}
            onChangePage={(page) => {
              setMeta('page', page)
            }}
          />
        </Flex>
      </Box>

      <CreateAdminModal disclosure={disclosure} />
    </Fragment>
  )
}

export default withApp(AdminsPage)
